import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AdvisorBarService {
    public advisorBar$: Observable<any>;
    private advisorBarSubject: Subject<any>;
  
    constructor() {
      this.advisorBarSubject = new Subject<any>();
      this.advisorBar$ = this.advisorBarSubject.asObservable();
    }

    refresh() {
        this.advisorBarSubject.next();
    }
  
    // add(message: string, type: any, clickable: number = 0, duration: number = 3000) {
    //   var snackBarMessage = {
    //     message,
    //     type,
    //     clickable,
    //     duration
    //   }
      
    //   this.snackBarSubject.next(snackBarMessage);
    // }
  }
